import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CommunicationService {
  private communcation = new Subject();

  constructor(private http: HttpClient) {}

  sendMsg(data): void {
    console.log(data);
    this.communcation.next(data);
  }

  receiveMsg(): Observable<any> {
    return this.communcation.asObservable();
  }

  addGroupEmp(req): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/communication/add_group_emp`,
      req
    );
  }
  // sms quota

  getQuota(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/communication/get_sms_quota`
    );
  }
  editSmsQuota(id): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/communication/edit_sms_quota/${id}`
    );
  }
  addBalance(data): Observable<any> {
    if (!data.id) {
      return this.http.post<any>(
        `${environment.apiUrl}/communication/add_sms_quota_action`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/communication/edit_sms_quota_action`,
        data
      );
    }
  }
  deleteSmsQuota(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/communication/delete_sms_quota`,
      data
    );
  }
  addComGroup(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/communication/add_comm_group`,
      data
    );
  }

  getComGroup(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/communication/get_comm_group`
    );
  }

  deleteRolMap(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/communication/delete_comm_group`,
      data
    );
  }

  addSmsQuota(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/communication/add_sms_quota`,
      data
    );
  }

  getSmsQuota(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/communication/get_quota_for_sms_`
    );
  }

  getSMSdltId(params): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/communication/get_sms_dtl_id`,
      params
    );
  }
  getSMSdltMessage(id): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/communication/get_sms_dtl/` + id
    );
  }
  sendSMS(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/communication/send_sms_action`,
      data
    );
  }

  getSmsDump(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/communication/get_sms_log_dump`
    );
  }

  getSMSTemplate(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/communication/get_sms_template`
    );
  }

  addSMSTemplate(data): Observable<any> {
    if (data.id == '' || data.id == null || data.id == undefined) {
      return this.http.post<any>(
        `${environment.apiUrl}/communication/add_sms_template`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/communication/edit_sms_template`,
        data
      );
    }
  }

  getNewsCategory(orgID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/communication/news/get_mapped_categories/${orgID}`
    );
  }

  createNews(data, txnId): Observable<any> {
    if (txnId) {
      return this.http.post<any>(
        `${environment.apiUrlsdx}/communication/news/edit_news_action`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrlsdx}/communication/news/add_news_action`,
        data
      );
    }
  }

  createGallery(data, txnId): Observable<any> {
    if (txnId) {
      return this.http.post<any>(
        `${environment.apiUrlsdx}/communication/news/edit_gallery_action`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrlsdx}/communication/news/add_gallery_action`,
        data
      );
    }
  }

  publishNews(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/communication/news/publish_news`,
      data
    );
  }

  publishGallery(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/communication/news/publish_gallery`,
      data
    );
  }

  deleteCommentNews(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/communication/news/delete_comment`,
      data
    );
  }

  updateCommentNews(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/communication/news/update_comment`,
      data
    );
  }

  deleteNews(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/communication/news/delete_news`,
      data
    );
  }

  deleteGalleryImgs(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/communication/news/delete_photos_gallery`,
      data
    );
  }

  deleteGalleryTxn(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/communication/news/delete_gallery_txn`,
      data
    );
  }

  editNews(nwsId): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/communication/news/edit_news/${nwsId}`
    );
  }

  getGeneralNews(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/communication/news/get_news_general`,
      { params: param }
    );
  }

  getGallery(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/communication/news/get_category_wise_gallery`,
      { params: param }
    );
  }

  getGalleryMaster(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/communication/news/get_gallery_master`,
      { params: param }
    );
  }

  getTrendingNews(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/communication/news/get_trending_news`,
      { params: param }
    );
  }

  getNewsStats(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/communication/news/view_stat`,
      { params: param }
    );
  }

  getNews(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrlsdx}/communication/news/get_news_master`,
      {
        params: param,
      }
    );
  }

  getNewsSubcat(catId): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/communication/news/get_subcategory/${catId}`
    );
  }

  getGalleryPhotos(txnId): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/communication/news/view_gallery/${txnId}`
    );
  }

  editGallery(txnId): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/communication/news/edit_gallery/${txnId}`
    );
  }

  getMappedCategoryList(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/communication/news/get_mapped_categories_list`
    );
  }

  getNewsUserStat(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/communication/news/get_news_Stat`
    );
  }

  pinNews(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/communication/news/pin_news`,
      data
    );
  }

  getCategory(data): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/communication/news/get_category?limit=${data.limit}&page=${data.page}&cat_desc=${data.cat_desc}`
    );
  }

  getNewsCateStatus(stat, CatId): Observable<any> {
    const option = {
      status: stat,
      cat_id: CatId,
    };
    const category = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/communication/news/edit_category_status_action`,
      category
    );
  }

  deleteCategory(cateId): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/communication/news/delete_category`,
      { cat_id: cateId }
    );
  }

  addCategory(req): Observable<any[]> {
    if (req.category_id === '') {
      return this.http.post<any[]>(
        `${environment.apiUrl}/communication/news/add_category_action`,
        req
      );
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/communication/news/edit_category_action`,
      req
    );
  }

  editCategory(catId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/communication/news/edit_category/` + catId
    );
  }

  getSubCategory(data): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/communication/news/get_sub_category?limit=${data.limit}&page=${data.page}&sub_desc=${data.sub_desc}`
    );
  }

  getNewsSubCateStatus(stat, subCatId): Observable<any> {
    const option = {
      status: stat,
      subcat_id: subCatId,
    };
    const subcategory = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/communication/news/edit_subcategory_status_action`,
      subcategory
    );
  }

  deleteSubCategory(subCateId): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/communication/news/delete_sub_category`,
      { subcat_id: subCateId }
    );
  }

  editSubCategory(subcatId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/communication/news/edit_sub_category/` + subcatId
    );
  }

  getCategoryId(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/communication/news/get_category_id`
    );
  }

  addSubCategory(req): Observable<any[]> {
    if (req.sub_category_id === '') {
      return this.http.post<any[]>(
        `${environment.apiUrl}/communication/news/add_sub_category_action`,
        req
      );
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/communication/news/edit_sub_category_action`,
      req
    );
  }
  getContactList(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    
    return this.http.get<any>(
      `${environment.apiUrl}/communication/contacts/get-contact-list`,
      { params: param }
    );
  }
  changeContactStatus(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/communication/contacts/update/status`,
      data
    );
  }


  editContact(Id): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/communication/contacts/edit/get/${Id}`
    );
  }
  addContact(data,id): Observable<any> {
    if(id){
      return this.http.post<any>(
        `${environment.apiUrl}/communication/contacts/edit/submit`,
        data
        );
    }else{
      return this.http.post<any>(
        `${environment.apiUrl}/communication/contacts/add-contact`,
        data
        );
    }
  }

  deleteContact(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/communication/contacts/del`,
      data
    );
  }
  // getAllEpa(data): Observable<any> {
  //   let param = new HttpParams();
  //   for (const key in data) {
  //     if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
  //       param = param.append(key, data[key]);
  //     }
  //   }
  //   return this.http.post<any>(`${environment.apiUrl}/communication/add_comm_group`, {params: param});
  // }
}
